import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { PublicQuotePage } from "@/public/PublicQuotePage";
import { StaffApp } from "@/staff/StaffApp";
import { LandingRedirect } from "@/LandingRedirect";

/**
 * Two surfaces in one SPA:
 *   /staff/*   → staff console (roles admin + staff)
 *   /:slug     → public quote page (unauthenticated, the public_slug route)
 *
 * Uses a data router (createBrowserRouter) so useBlocker works — the block
 * builder guards unsaved changes against ALL in-app navigation, not just its
 * own back link. The staff console still mounts its own descendant <Routes>.
 */
const router = createBrowserRouter([
  { path: "/staff/*", element: <StaffApp /> },
  { path: "/", element: <LandingRedirect /> },
  { path: "/:slug", element: <PublicQuotePage /> },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export function App() {
  return <RouterProvider router={router} />;
}
